interface AuthUser {
  emailVerified: boolean;
  getIdTokenResult(): Promise<{ claims: Record<string, unknown> }>;
}

export async function hasTotpSignIn(user: AuthUser | null): Promise<boolean> {
  if (!user?.emailVerified) {
    return false;
  }

  const token = await user.getIdTokenResult();
  return token.claims['totpAuthTime'] === token.claims['auth_time'];
}
